import classnames from 'classnames';
import { useMatch } from 'react-router-dom';

import { LinkWithQuery } from '../LinkWithQuery/LinkWithQuery';

export const NavBarLink = ({
  to,
  children,
  className,
  activeClass,
  isExternalLink,
  ...props
}: {
  to: string;
  children: React.ReactNode;
  className?: string;
  activeClass?: string;
  isExternalLink?: boolean;
}) => {
  const match = useMatch(to + '*');
  const getLinkClassName = (): string | undefined => {
    if (!activeClass) return className;

    return classnames(className, {
      [activeClass]: match,
    });
  };

  return isExternalLink ? (
    <a {...props} href={to} className={getLinkClassName()}>
      {children}
    </a>
  ) : (
    <LinkWithQuery {...props} to={to} className={getLinkClassName()}>
      {children}
    </LinkWithQuery>
  );
};
